import styles from "./select.module.css";
import constants from "../../../constants";

const Select = ({id, onChange, additionalStyle, color, currentValue, options, disabled}) => {
    return (
    <select id={id}
      style={{
        color: color ? color : constants.colors.cplNavy,
        border: `1px solid ${color ? color : constants.colors.cplNavy}`,
        textOverflow: 'ellipsis'
      }}
      disabled={disabled ? disabled : false}
      onChange={onChange}
      value={currentValue}
      className={`${styles.Select} ${additionalStyle ? additionalStyle : ""}`}>
        {options.map(option => {
            return (
              <option key={option.value} 
                      value={option.value}
                      label={option.label}
                      disabled={option.disabled}>
                {option.label}
              </option>
            )
        })}
      </select>
    )
}

export default Select;